import { BasicCouponFragment } from 'drycut-graphql';

type Props = {
  tax?: number;
  coupon: BasicCouponFragment | undefined;
  service: { price: number; kidsPrice?: number | null | undefined } | undefined | null;
  kidCustomer: boolean;
};

export function computeBookingPrice({
  tax = 0,
  service,
  coupon,
  kidCustomer = false,
}: Props): number {
  // If there is a coupon and the coupon price is 0, the booking is free. Otherwise we need to add
  // the tax to the coupon price.
  if (coupon) {
    return coupon.price === 0 ? 0 : coupon.price + tax;
  }

  if (kidCustomer && service?.kidsPrice) {
    return service.kidsPrice;
  }

  return (service?.price || 0) + tax;
}
